import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {IDataTableService} from '../common/interfaces/data-table-service.interface';
import {ITableColumn} from '../common/interfaces/table-column.interface';
import {StorageService} from './storage.service';
import {ActivatedRoute} from '@angular/router';
import {EXTENDED_SETTINGS_COLUMN, SETTINGS_COLUMN} from '../../shared/components/table/table.component';
import {Sort} from '@angular/material/sort';
import {UserTableSettingsService} from './user-table-settings.service';
import {USER_TABLE_POSTFIX, USER_TABLE_SORT_POSTFIX} from '../../app.config';

const REGISTER_COLUMNS = 'REGISTER_COLUMNS';

@Injectable({
    providedIn: 'root'
})
export class RegisterDataTableService implements IDataTableService<any> {
    route = inject(ActivatedRoute);
    userTableSettingsService = inject(UserTableSettingsService);
    userTablePostfix = inject(USER_TABLE_POSTFIX)
    userTableSortPostfix = inject(USER_TABLE_SORT_POSTFIX)

    data$$: BehaviorSubject<any> = new BehaviorSubject([]);
    data$: Observable<any> = this.data$$.asObservable();

    showCustomColumns = true;

    key: string = '';

    constructor(
        private storageService: StorageService,
    ) {
        this.route.snapshot.url.length
        && this.route.snapshot.url[0].path
        && (this.key = this.route.snapshot.url[0].path + this.userTablePostfix);
    }

    getData(): any[] {
        return this.data$$.getValue();
    }

    setColumns(columns: ITableColumn[]): void {
    }

    getColumns(): ITableColumn[] {
        return [
            {
                name: 'isSelected',
                title: '',
                isRequired: true,
                settingTitle: 'Приоритет',
                useCustomTemplate: true,
            },
            {
                name: 'id',
                title: 'Id',
                isRequired: true,
                useCustomTemplate: false,
            },

            {
                name: 'rateGroup',
                title: 'Группа оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'rateSubGroup',
                title: 'Подгруппа оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'rateKind',
                title: 'Вид оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'name',
                title: 'Название',
                useCustomTemplate: false,
            },
        ];
    }

    getCustomColumns(): string[] {
        // return JSON.parse(this.storageService.getItem(REGISTER_COLUMNS) || '[]');
        const parsable = this.storageService.getItem(this.key);
        return parsable ? JSON.parse(parsable) : [...this.getColumns().map(col => {
            const res = col.default || col.isRequired ? col.name : null;
            return res;
        }).filter(v => v !== null), SETTINGS_COLUMN];
    }

    setCustomColumns(columnNames: string[]): void {
        this.storageService.setItem(this.key, JSON.stringify(columnNames));
        this.userTableSettingsService.saveOrders(this.key, columnNames)
    }

    setData(data: {
        pager: any;
        values: { firm: string; facilityAddress: string; id: number; facility: string; createAt: string }[]
    }): void {
        this.data$$.next(data);
    }

    setSorting(value: Sort): void {
        const key = this.route.snapshot.url[0].path + this.userTableSortPostfix;
        this.storageService.setItem(key, JSON.stringify(value));
        this.userTableSettingsService.saveSorting(key, value)
    }

    getSorting(): Sort|null {
        try {
            const key = this.route.snapshot.url[0].path + '-table-sort';
            const parsable = this.storageService.getItem(key);
            return parsable ? JSON.parse(parsable) : null;
        } catch (e) {
            return null;
        }
    }
}
